export const LOCAL_STORAGE_LOCALE = "app-locale";
export const LOCAL_STORAGE_KIOSK_SESSION = "kiosk-session";
